(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("feature-collection-reprojection", [], factory);
	else if(typeof exports === 'object')
		exports["feature-collection-reprojection"] = factory();
	else
		root["feature-collection-reprojection"] = factory();
})(self, function() {
return 